// extracted by mini-css-extract-plugin
export default {"ship-accordion":"ShipOverview_ship-accordion__ufb3v","container":"ShipOverview_container__bQp9n","wrap-container":"ShipOverview_wrap-container__FrL0A"};